import * as Yup from 'yup';
import { conditionalRequired, getDefaultItemId } from 'src/components/formik-utils';

export const initialValues = (item) => {
  const myId = getDefaultItemId(item);
  if(0 < myId){
    const isRemoved = !item.courseName;
    return {
      isRemoved,
      btnLabel: 'Cập nhật',
      id: myId,
      name: item.name ?? '',
      phone: item.phone ?? '',
      birthday: item.birthday ?? '',
      email: item.email ?? '',
      identityCard: item.identityCard ?? '',
      genderLabel: item.genderLabel ?? null,
      address: item.address ?? '',
      // avatar: item.avatar ?? null,
      // gender: item.gender ?? null,
      note: item.note ?? null,
      degreeName: item.degreeName ?? null,
      partnerName: item.partnerName ?? null,
      partnerContact: item.partnerContact ?? '',
      groupName: item.groupName ?? null,
      // firstCode: item.firstCode ?? '',
      // secondCode: item.secondCode ?? '',
    }
  }
  return {
    isRemoved: false,
    btnLabel: 'Tạo tài khoản',
    id: 0,
    name: '',
    phone: '',
    birthday: '',
    email: '',
    identityCard: '',
    genderLabel: null,
    address: '',
    // avatar: null,
    // gender: null,
    note: null,
    degreeName: null,
    partnerName: null,
    partnerContact: null,
    groupName: null,
    // firstCode: '',
    // secondCode: '',
  }
};

export const validationSchema = (myId) => {
  const isRequired = myId === 0;

  const schema = Yup.object({
    nameField: conditionalRequired(Yup.string(), 'Tên học viên không được trống', isRequired),
    phoneField: conditionalRequired(Yup.string(), 'Sđt phải có', isRequired),
    degreeField: conditionalRequired(Yup.object(), 'Vui lòng chọn hạng', isRequired),
    partnerField: conditionalRequired(Yup.object(), 'Vui lòng chọn đối tác', isRequired)
  });
  return schema;
};

export const handleSubmitted = async (
  myId, values, apiInsert, apiUpdate, apiRemove
) => {
  if(0 < myId){
    values.id = myId;
    if(values.isVerified){
      apiRemove(values);
    }else{
      apiUpdate(values);
    }
  }else{
    apiInsert(values);
  }
};
